var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { DropdownChecklist } from '@hn-ui/dropdowns';
import { dropdownItemsNoTBDFull } from '@hn-front/data-types';
var gradeItems = __spreadArray([
    { id: 'all', text: 'All grades', value: -100 }
], dropdownItemsNoTBDFull, true);
var GradeDropdown = function (_a) {
    var values = _a.values, onChange = _a.onChange, rest = __rest(_a, ["values", "onChange"]);
    var valuesWithAll = useMemo(function () { return __spreadArray([], values, true); }, [values]);
    if (values.length === 7)
        valuesWithAll.push(__assign(__assign({}, gradeItems[0]), { disabled: values.every(function (v) { return v.disabled; }) }));
    var gradeItemsParsed = useMemo(function () {
        return gradeItems.map(function (item) {
            return (__assign(__assign({}, item), { disabled: valuesWithAll.some(function (v) { return v.value === item.value && v.disabled; }) }));
        });
    }, [valuesWithAll]);
    var handleOnChange = useCallback(function (items) {
        var isAllNow = items.some(function (i) { return i.value === -100; });
        var isAllPrev = valuesWithAll.some(function (i) { return i.value === -100; });
        if (isAllPrev && !isAllNow)
            onChange(items.filter(function (item) { return item.disabled; }));
        else if (!isAllPrev && isAllNow)
            onChange(__spreadArray([], gradeItemsParsed, true));
        else
            onChange(items.filter(function (item) { return item.value !== -100; }));
    }, [onChange, valuesWithAll, gradeItemsParsed]);
    return (_jsx(DropdownChecklist, __assign({ items: gradeItemsParsed, fit: true, placeholder: 'Select Grades', compact: true, label: 'Select grade(s)', selectedItems: valuesWithAll, onChange: handleOnChange }, rest), void 0));
};
export { GradeDropdown };
